export const BASE_URL =
  location.protocol +
  '//' +
  location.hostname +
  (location.port ? ':' + location.port : '');
